import {
  IItem,
  ICalculatedValueValidatable,
} from "../items";
import { AbstractDocumentItemAlert } from "./AbstractDocumentItemAlert";

export class CalculationAlert extends AbstractDocumentItemAlert<IItem & ICalculatedValueValidatable> {
  constructor(itemSetId: number, item: IItem & ICalculatedValueValidatable) {
    super(itemSetId, item, false);
  }

  get kind(): string {
    return "計算不可";
  }

  get target(): string {
    return "計算エリア「"
      + (this._detectedItem.name ? this._detectedItem.name : "")
      + "」";
  }

  get description(): string {
    return "値が未入力のエリアが含まれているため、計算できません。";
  }
}
